import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { RescheduleFilterBar } from "./ui/RescheduleFilterBar";
import { RescheduleList } from "./ui/RescheduleList";

export const ReschedulePage = () => {
  return (
    <PageLayout pageTitle="Umdisponierung/ Folgetermin">
      <div className="flex w-full flex-col gap-4">
        <RescheduleFilterBar />
        <RescheduleList />
      </div>
    </PageLayout>
  );
};
